import { DatePicker as DatePicker, DatePickerInput } from "@carbon/react";
import { appConfig } from "../../configs";
// import calendarIcon from "../../assets/icons/calendar.svg";

export const View = ({
  name,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  ...rest
}) => {
  // console.log(startDate);
  // console.log(endDate);
  return (
    <div className="flex-container row">
      <DatePicker
        dateFormat={appConfig.dateFormat2}
        datePickerType="range"
        size="sm"
        className="date-range--picker"
        onChange={(e) => {
          if (e[0]) {
            setStartDate(e[0]);
          }
          if (e[1]) {
            setEndDate(e[1]);
          }
          console.log(e);
        }}
        {...rest}
      >
        <DatePickerInput
          id={`${name}-date-picker-range-start`}
          // placeholder={appConfig.dateFormat1}
          // labelText="Start Date"
          type="text"
          value={startDate}
          datePickerType="range"
        />
        <DatePickerInput
          id={`${name}-date-picker-range-end`}
          // placeholder={appConfig.dateFormat1}
          // labelText="End Date"
          type="text"
          value={endDate}
          datePickerType="range"
          // onChange={(e) => {
          //   console.log("e");
          // }}
        />
      </DatePicker>
    </div>
  );
};
